import React, { useRef, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ResponsiveFunnel } from '@nivo/funnel';


const data = [
    { id: 'Lead', name: 'Lead', value: 1000 },
    { id: 'Prospect', name: 'Prospect',  value: 700 },
    { id: 'Pre-Approved', name: 'Pre-Approved', value: 500 },
    { id: 'Contract', name: 'Contract', value: 300 },
    { id: 'Funded', name: 'Funded', value: 100 },
];

const dataWithConversions = data.map((item, index) => {
    if (index === 0) return { ...item, conversion: null };
    const conversion = ((item.count / data[index - 1].count) * 100).toFixed(1);
    return { ...item, conversion: `${conversion}%` };
} );

// Component rendering the chart
const FunnelBarChart = () => {
    useEffect( () => {
        console.log( 'conversions: ', dataWithConversions );
    }, [  ] );
    
    return (
        <Container fluid>
            <Row>
                <Col className='p-2'>
                    <Row>
                        <Col>
                            Funnels
                        </Col>
                    </Row>
                    <Row>
                        <Col xs='auto' style={{
                            background: 'rgba(0, 115, 177, 0.1)',
                            borderRadius: '10px', // Rounds the corners
                            boxShadow: '0 4px 5px rgba(0, 0, 0, 0.4)', // Optional shadow for aesthetics
                            height: '250px',
                            width: '500px'
                        }}>
                            <ResponsiveFunnel
                                data={dataWithConversions}
                                margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
                                // valueFormat=" >-s"
                                colors={{ scheme: 'oranges' }}
                                borderColor={{
                                    from: 'color',
                                    modifiers: [
                                        ['darker', 1],
                                        ['opacity', .5]
                                    ]
                                }}
                                // borderWidth={20}
                                // label={ (d) => `${d.id}: ${d.conversion}`}
                                // label={null}
                                // layers={['separators', 'parts', 'labels', 'annotations']}
                                labelColor={{ from: 'color', modifiers: [['darker', 2]] }}
                                // beforeSeparatorLength={50}
                                // beforeSeparatorOffset={20}
                                // afterSeparatorLength={50}
                                // afterSeparatorOffset={20}
                                // currentPartSizeExtension={10}
                                // currentBorderWidth={40}
                                motionConfig="wobbly"
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    meta: state.user.meta,
    user: state.user,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
    lists: state.lists.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( FunnelBarChart );